import parse from 'html-react-parser';
import { FC, ReactNode, useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import Paragraph from 'quarks/Paragraph';
import type { BasicProps } from 'quarks/interpolations/basic';

const EmbedContainer = styled.span`
  display: flex !important;
  flex: 1 0 100%;
  height: inherit;
  width: inherit;
  max-width: inherit;
  iframe {
    display: block;
    margin: 0 auto;
  }
  @media (max-width: 632px) {
    iframe,
    object,
    embed {
      max-width: 440px;
      min-height: 100%;
    }
  }
  @media (max-width: 575px) {
    iframe {
      max-width: 100%;
    }
    object,
    embed {
      max-width: 100%;
      min-height: 240px;
      height: auto;
    }
  }
`;
/* eslint-disable no-nested-ternary */
export const reduceContentValues: any = (content: any) =>
  content && Array.isArray(content)
    ? content.reduce(
        (prev, cur) => prev + (cur?.value || cur?.content?.reduce((p: any, c: any) => p + c?.value, '')),
        '',
      )
    : content?.content || content?.raw
    ? reduceContentValues(content?.content || JSON.parse(content?.raw))
    : '';

interface RichTextParagraphBlockProps extends BasicProps {
  children?: ReactNode | undefined;
  node?: any | undefined;
  bareOptions?: any | undefined;
}

const getScript = (content: string) =>
  content.substring(content.indexOf('<script>') + 8, content.lastIndexOf('</script>'));

const RichTextParagraphBlock: FC<RichTextParagraphBlockProps> = ({
  children,
  node,
  bareOptions,
  ...otherProps
}: RichTextParagraphBlockProps) => {
  const contentString = reduceContentValues(node?.content) || '';
  const paragraphText =
    children && Array.isArray(children) && children.join().startsWith('<') ? parse(children.join()) : children;

  useEffect(() => {
    try {
      if (!contentString.includes('<script')) {
        return;
      }
      const js = [getScript(contentString)];
      js.forEach((j: string) => {
        new Function(j)();
      });
    } catch (err) {
      console.log('Innerhtml Javascript script code contained an error:', err);
    }
  }, []);

  if (contentString.includes('<iframe') || contentString.includes('<div')) {
    const contentHtml = reduceContentValues(node?.content) || '';

    return <EmbedContainer {...otherProps} dangerouslySetInnerHTML={{ __html: contentHtml }} />;
  } else if (contentString.includes('<script') || contentString.includes('<link')) {
    const contentHtml = reduceContentValues(node?.content) || '';

    return <Helmet {...otherProps}>{parse(contentHtml)}</Helmet>;
  } else {
    return bareOptions ? (
      paragraphText
    ) : (
      <>
        {children && Array.isArray(children) && children.join().startsWith('<') ? (
          parse(children.join())
        ) : (
          <Paragraph>{children}</Paragraph>
        )}
      </>
    );
  }
};

export default RichTextParagraphBlock;
